import React from 'react';
import { useNavigate } from 'react-router-dom';
import Login from './Login';
import Footer from '../Footer';
import AuthHeader from '../AuthHeader';

function LoginPage({ navigate }) {
  const handleSignIn = ({ success }) => {
    if (success) {
      navigate('/');
    }
  };

  return (
    <div className="auth-page-container">
      <div className="auth-content">
        <div className="container">
          <AuthHeader />
          <div className="auth-form-container">
            <Login handleSignIn={handleSignIn} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

const LoginPageWithNavigate = (props) => {
  const navigate = useNavigate();
  return <LoginPage {...props} navigate={navigate} />;
};

export default LoginPageWithNavigate;
